export interface ShipToCountryLike {
  readonly country?: string;
}

/** Values ShipStation may send for domestic United States ship-to. */
const US_DOMESTIC_COUNTRY_VALUES = new Set([
  'US',
  'USA',
  'UNITED STATES',
  'UNITED STATES OF AMERICA',
]);

/**
 * True when shipTo.country identifies the United States.
 * Missing/blank country is treated as non-domestic (excluded).
 */
export function isUsDomesticShipTo(shipTo: ShipToCountryLike | undefined): boolean {
  const country = shipTo?.country?.trim().toUpperCase();
  if (!country) {
    return false;
  }
  return US_DOMESTIC_COUNTRY_VALUES.has(country);
}

/**
 * True when shipTo.country is present and identifies a non-US destination.
 * Missing/blank country is excluded (not international) so the UI stays silent on unknowns.
 * This is deliberately not `!isUsDomesticShipTo` — blank country is excluded from both.
 */
export function isInternationalShipTo(shipTo: ShipToCountryLike | undefined): boolean {
  const country = shipTo?.country?.trim().toUpperCase();
  if (!country) {
    return false;
  }
  return !US_DOMESTIC_COUNTRY_VALUES.has(country);
}
